module.exports = __webpack_public_path__ + "media/rukou.240f01a0.mp3";